import createReducer from 'utils/createReducer';

const SET_CLOSE_MODAL = 'error-handler/SET_CLOSE_MODAL';
const SET_NEW_ERROR = 'error-handler/SET_NEW_ERROR';

// Initial State
const INIT_STATE = {
  show: false,
  title: '',
  description: '',
};

// Reducers
export default createReducer(INIT_STATE, {
  [SET_NEW_ERROR](state, { title, description }) {
    return {
      ...state,
      show: true,
      title,
      description,
    };
  },
  [SET_CLOSE_MODAL](state) {
    return INIT_STATE;
  },
});

export const setNewError = (title, description) => {
  return {
    type: SET_NEW_ERROR,
    payload: {
      title,
      description,
    },
  };
};
export const setErrorModalClosed = () => {
  return {
    type: SET_CLOSE_MODAL,
  };
};
